"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    Skeleton: ()=>Skeleton
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_Skeleton_variants_cjs_namespaceObject = require("./Skeleton.variants.cjs");
const external_BaseSkeleton_cjs_namespaceObject = require("./BaseSkeleton.cjs");
function Skeleton({ className, type, width, height, emphasis = 'regular', ...props }) {
    const { skeletonWrapperSlot, skeletonSlot, skeletonImageSlot } = (0, external_Skeleton_variants_cjs_namespaceObject.skeletonVariants)({
        type,
        emphasis,
        ...props
    });
    const widthStyle = 'number' == typeof width ? `${width}px` : width;
    const heightStyle = 'number' == typeof height ? `${height}px` : height;
    const styles = {
        width: width ? widthStyle : void 0,
        height: height ? heightStyle : void 0
    };
    return type && type in external_Skeleton_variants_cjs_namespaceObject.skeletonTypographyTypes ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
        "data-testid": "skeleton-wrapper",
        className: skeletonWrapperSlot(),
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_BaseSkeleton_cjs_namespaceObject.BaseSkeleton, {
            type: type,
            className: className,
            skeletonSlot: skeletonSlot(),
            skeletonImageSlot: skeletonImageSlot(),
            styles: styles
        })
    }) : /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_BaseSkeleton_cjs_namespaceObject.BaseSkeleton, {
        type: type,
        className: className,
        skeletonSlot: skeletonSlot(),
        skeletonImageSlot: skeletonImageSlot(),
        styles: styles
    });
}
exports.Skeleton = __webpack_exports__.Skeleton;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "Skeleton"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
